import { Button, Link } from "@nextui-org/react";
import { useEffect } from "react";
import hamty from "../assets/hamty.png";
import { YouTube } from "./icons/YouTube";

export const Footer = () => {
	useEffect(() => {
		const iframe = document.createElement("iframe");
		iframe.style.border = "none";
		iframe.className = "w-max max-h-12";

		document.getElementById("wedos-script")?.appendChild(iframe);

		iframe.onload = () => {
			const iframeDoc =
				iframe.contentDocument || iframe.contentWindow?.document;

			if (iframeDoc) {
				iframeDoc.open();
				iframeDoc.write(`
					<script>
						_adsys_id = 36396;
						_adsys_size = 1;
					</script>
					<script src="https://d.wedosas.net/d.js"></script>
				`);
				iframeDoc.close();

				// Fallback: Check periodically if the element exists
				const interval = setInterval(() => {
					const adsys =
						iframe.contentDocument?.getElementsByClassName("adsys")[0];
					if (adsys) {
						const img = adsys.getElementsByTagName("img")[0];
						if (img) {
							img.setAttribute("width", "291");
							img.setAttribute("height", "36");
							clearInterval(interval);
						}
					}
				}, 100);

				const observer = new MutationObserver(() => {
					const adsys =
						iframe.contentDocument?.getElementsByClassName("adsys")[0];
					if (adsys) {
						const img = adsys.getElementsByTagName("img")[0];
						if (img) {
							img.setAttribute("width", "291");
							img.setAttribute("height", "36");
							observer.disconnect();
							clearInterval(interval);
						}
					}
				});

				if (iframeDoc.body) {
					observer.observe(iframeDoc.body, { childList: true, subtree: true });
				}
			}
		};

		return () => {
			iframe.remove();
		};
	}, []);

	return (
		<footer className="fixed bottom-0 left-0 z-20 w-full px-4 shadow bg-background/70 border-t border-divider grid grid-cols-1 md:grid-cols-3 items-center">
			<div>
				<Button
					showAnchorIcon
					as={Link}
					color="danger"
					href="https://www.youtube.com/channel/UCQlGd6P3K6IktYOLvQqvQpw"
					anchorIcon={<YouTube />}
					isExternal
					isBlock
				>
					YouTube
				</Button>
			</div>
			<div className="mx-auto">
				<p>&copy; {new Date().getFullYear()} RTL</p>
			</div>
			<div className="flex flex-row justify-end gap-2">
				<div id="wedos-script" />
				<a href="https://hamty.cz" target="_blank" rel="noreferrer">
					<img
						src={hamty}
						title="Nejštědřejší cashback"
						alt="hamty"
						className="max-h-12 py-1"
					/>
				</a>
			</div>
		</footer>
	);
};
